import styled from 'styled-components';

export const ComplaintButtonStyles = styled.div`
  font-size: ${({ theme }) => theme.fontSize.nm};
  .content {
    max-width: 450px;
  }

  button {
    cursor: pointer;
  }
`;
